/**
 * The storefront.
 *
 * Itch's real feature is pay-what-you-want with a suggested price that's
 * purely advisory — you can always take $0. Scratchyo keeps that mechanic
 * (nobody is ever blocked from claiming), which is what makes it a genuine
 * storefront and not just a rejection wall. The joke lives entirely in what
 * the Suggested Price has to SAY about your number on the way through.
 *
 * Static and hand-written, same as Regretsit's feed — there is no real upload
 * pipeline here, so there is nothing to store and nothing to moderate.
 */

export interface Listing {
  id: string
  title: string
  dev: string
  tag: string
  blurb: string
  /** The dev's suggested price, in whole dollars. Never a hard minimum. */
  suggested: number
}

export const LISTINGS: Listing[] = [
  {
    id: 'l0',
    title: 'GRIEVANCE ENGINE',
    dev: 'sunk_cost_games',
    tag: 'roguelike',
    blurb: 'Every run you carry your regrets to the next one. That is the whole mechanic.',
    suggested: 8,
  },
  {
    id: 'l1',
    title: 'Adjunct Wizard Simulator',
    dev: 'three_office_hours',
    tag: 'sim',
    blurb: 'Cast spells between grading. Tenure is a rare drop.',
    suggested: 5,
  },
  {
    id: 'l2',
    title: 'the raft knows',
    dev: 'devon_no_relation',
    tag: 'narrative',
    blurb: 'A quiet game about a raft. It does not know anything. That is also the point.',
    suggested: 3,
  },
  {
    id: 'l3',
    title: 'Foldable Dungeon Vol. II',
    dev: 'papercut_press',
    tag: 'print-and-play PDF',
    blurb: 'Scissors not included. Your printer will make its own decisions about the blue.',
    suggested: 4,
  },
  {
    id: 'l4',
    title: 'Weekend Boss Rush',
    dev: 'one_more_jam',
    tag: 'jam game',
    blurb: 'Made in 48 hours and it shows, lovingly.',
    suggested: 0,
  },
]

/** Ambient Itch Browser chatter — tasteful snobs, never wrong. */
export const BROWSER_QUOTES = [
  '"We only back when it\'s already done." — a review, from someone who waited',
  '"Wishlisted. Will revisit at 1.0, if there is one." — a review, four builds ago',
  '"Refunding on principle, the principle being I finished it in an evening."',
]
